export const ACADEMY_TRAINING_SCHEDULE = [
  {
    team: 'K10',
    label: 'Κ-10',
    coach: 'Ευτυχία Χατζάκη',
    sessions: [
      { day: 'Δευτέρα', time: '19:30 – 21:00' },
      { day: 'Πέμπτη', time: '17:00 – 18:00' },
      { day: 'Παρασκευή', time: '18:00 – 19:30' },
    ],
  },
  {
    team: 'K12',
    label: 'Κ-12',
    coach: 'Σουζάνα Ζντράβκοβιτς',
    sessions: [
      { day: 'Τρίτη', time: '17:00 – 18:00' },
      { day: 'Πέμπτη', time: '17:00 – 18:00' },
      { day: 'Παρασκευή', time: '18:00 – 19:30' },
    ],
  },
];

export const ACADEMY_STAFF = [
  {
    name: 'Κώστας Κολοκοτρώνης',
    searchToken: 'ΚΟΛΟΚΟΤΡΩΝ',
    role: 'Τεχνικός Διευθυντής Ακαδημίας',
    group: 'technical',
    email: 'costaskolokotronis@gmail.com',
  },
  {
    name: 'Σουζάνα Ζντράβκοβιτς',
    searchToken: 'ΖΤΡΑΒΚΟΒΙΤΣ',
    role: 'Προπονήτρια Κ-12',
    group: 'coaches',
  },
  {
    name: 'Ευτυχία Χατζάκη',
    searchToken: 'ΧΑΤΖΑΚ',
    role: 'Προπονήτρια Κ-10',
    group: 'coaches',
  },
  {
    name: 'Γιώργος Αντωνάκης',
    searchToken: 'ΓΙΩΡΓΟΣ ΑΝΤΩΝΑΚΗΣ',
    role: 'Υπεύθυνος Ακαδημίας',
    group: 'managers',
    phone: '6981037223',
  },
  {
    name: 'Γιώργος Πουλάκης',
    searchToken: 'ΠΟΥΛΑΚ',
    role: 'Υπεύθυνος Ακαδημίας',
    group: 'managers',
    phone: '6996204475',
  },
  {
    name: 'Νικήτας Μπραουδάκης',
    searchToken: 'ΜΠΡΑΟΥΔΑΚ',
    role: 'Υπεύθυνος Ακαδημίας',
    group: 'managers',
    phone: '6993188718',
  },
];

export const academyScheduleSummary = ACADEMY_TRAINING_SCHEDULE.map(
  ({ label, sessions }) => `${label}: ${sessions.map(({ day, time }) => `${day} ${time}`).join(' • ')}`
);
